import { LoaderFunctionArgs, redirect } from "react-router-dom";
import { getConnectionId } from "utils/localStorageServices";

export async function viewerModeConnectionGuardLoader({
  params,
}: LoaderFunctionArgs) {
  const friendlyId = params.friendlyId;

  if (!friendlyId) {
    throw new Response("Event not found", { status: 404 });
  }

  if (!getConnectionId()) {
    return redirect(`/join/${friendlyId}`);
  }

  return null;
}
